import React, { useEffect } from 'react';
import axios from 'axios';
import './PositionsTable.css';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';


const useStyles = makeStyles({ //יצירת סטיילינג
  root: { //דיב רוט 
    width: '100%',
  },
  container: { // דיב חיצוני ביותר
    maxHeight: 800,
  },
});

export default function StickyHeadTable(props) { //הפונקציה של הטבלה
  const classes = useStyles(); //שימוש בסטיילינג לפי קלאסים
  const [page, setPage] = React.useState(0); //סטייט של הפאג'ינציה (עמודים)
  const [rowsPerPage, setRowsPerPage] = React.useState(11); //כמות שורות פר עמוד
  const [positions, setPositions] = React.useState([]);
  const [openSymbols, setOpenSymbols] = React.useState('');
  const [trackRecord, setTrackRecord] = React.useState('');

  const handleAvailableSymbolsChange = ({target}) => {
    setOpenSymbols(target.value);
  };


  const bondsSymbols = ()=> {
    window.open("https://docs.google.com/spreadsheets/d/1VZOFoAPhfIigwNSD8j4SjM3VXvJI17uKasW-KH-hjvk/edit#gid=0", '_blank')
  }

  const pairsSymbols = ()=> {
    window.open("https://docs.google.com/spreadsheets/d/13WBfVqtgm1lpx230yJyvFVxzgGzOwm96BRDtXTq_dMY/edit#gid=0", '_blank')
  }

  const cryptoSymbols = ()=> {
    window.open("https://docs.google.com/spreadsheets/u/2/d/1AXKooJnZS8j5HoZVLdmls8jh1B9SN7Xyw7EVzClqRW4/edit#gid=0", '_blank')
  }

  const comoditySymbols = ()=> {
    window.open("https://docs.google.com/spreadsheets/d/1qQSdmshVsYaP_fvwwDx27UlZBe_R57-R8ixmHtqceTU/edit#gid=0", '_blank')
  }

  const stocksSymbols = ()=> {
    window.open("https://docs.google.com/spreadsheets/u/2/d/1DmFY6gaN8xzYpNCVg6nOE9xpm05zqKQ97vPzXuZ6Dj0/edit#gid=1238020137", '_blank')
  }

  const indexesSymbols = ()=> {
    window.open("https://docs.google.com/spreadsheets/d/1pN6EFAZOOcmH_34fO1IzlSlEHX6lle3qB4xAYiBjFE8/edit#gid=0", '_blank')
  }


  const columns = [  // עמודות לטבלה הראשית
    {
      id: 'Num',
      label: 'Num',
      minWidth: 50
    },
    {
      id: 'Symbol',
      label: 'Symbol',
      minWidth: 50,
    },
    {
      id: 'Operation',
      label: 'Operation',
      minWidth: 50
    },
    {
      id: 'StartDate',
      label: 'Start Date',
      minWidth: 50,
    },
    {
      id: 'EndDate',
      label: 'End Date',
      minWidth: 50,
    },
    {
      id: 'StartPrice',
      label: 'Start Price',
      minWidth: 50,
    },
    {
      id: 'EndPrice',
      label: 'End Price',
      minWidth: 50,
    },
    {
      id: 'succeeded',
      label: 'Succeeded',
      minWidth: 50,
    },
    {
      id: 'PipsesCents',
      label: 'Pipses/Cents',
      minWidth: 50,
    },
    {
      id: 'Precent',
      label: 'Success rate (per page)',
      minWidth: 50,
    },
    {
      id: 'positionId',
      label: 'Position ID',
      minWidth: 50,
    },
    {
      id: 'symbolType',
      label: 'symbolType',
      minWidth: 50,
    },
  ];

  function createData( //פונקציה המייצרת דאטא חדש לטבלה
    Num,
    Symbol,
    Operation,
    StartDate,
    EndDate,
    StartPrice,
    EndPrice,
    succeeded,
    PipsesCents,
    Precent,
    positionId,
    symbolType
  ) {
    return { Num, Symbol, Operation, StartDate, EndDate, StartPrice, EndPrice, succeeded, PipsesCents, Precent,positionId,symbolType };
  }


  const handleChangePage = (event, newPage) => { //פונקציה לשינוי עמוד
    setPage(newPage); //שינוי הסטייט לעמוד חדש
  };

  const handleChangeRowsPerPage = (event) => { //אפשרות למשתמש לשנות את מספר השורות בעמוד (כרגע מבוטל)
    setRowsPerPage(+event.target.value); //המספר שהמשתמש בחר
    setPage(0);
  };

  // פונקציה שמוסיפה אחוזי הצלחה בראש כל עמוד + משנה ערכים שהם אנדיפיינד
  const addSuccessRate = (arr) => {
    let arrays = [];
    const size = 10;
    let ratesArray = [];
    // חותך את המערך לצ'אנקים של 10 או פחות
    for (let i = 0; i < arr.length; i += size) {
      arrays.push(arr.slice(i, i + size));
    }
    //לולאת פור איצ
    arrays.forEach(chunk => {
      //מוצא את מספר הפוזיציות שהצליחו
      let succeeded = chunk.filter(item => item.succeeded === 'true').length;
      // מוצא את מספר הפוזיציות שעדיין לא נסגרו
      let unClosedPositions = 0;
      chunk.map((item) => {
        if (item.succeeded === 'undefined') { //במידה וסוקסידד אנדיפיינד
          item.succeeded = 'Position is open'
          unClosedPositions++; // לא סופר פוזיציות פתוחות בחישוב האחוזים
        };
        if (!item.EndPrice) { // במידה ואין מחיר סגירה
          item.EndPrice = 'Position is open'
        }
        if (!item.PipsesCents) { // במידה ואין פיפסים
          item.PipsesCents = 'Position is open'
        }
      });
      // מוצא את אחוזי ההצלחה לפי החישוב הבא: מספר הפוזיציות שהצליחו לחלק לגודל הצ'אנק פחות מספר הפוזיציות שלא נסגרו
      let rate = (succeeded / (chunk.length - unClosedPositions)) * 100;
      rate = rate?.toFixed() + '%';
      if (rate === 'NaN%') {
        rate = '0%'
      };
      ratesArray.push(rate);
    });
    arrays.map((array, idx) => array.unshift(createData('', '', '', '', '', '', '', '', '', ratesArray[idx]))); //הכנסה של עמודת אחוזים לטבלה
    return arrays.flat()
  }

  //פונקציה שמביאה את כל הפוזיציות והמידע של המשתמש

  const getUserData = async () => {
    try {
      // Fetch user details and positions in parallel

      const details = await axios.get('/auth/userDetails'); // API שמביא דאטא על המשתמש
      const userPositions = await axios.get(`/positions/getUserPositions/${details.data.email}`); // API שמביא את הפוזיציות של המשתמש
     
  
      // Define the position types to process
      const positionTypes = [
        { key: 'bonds', symbolType: 'bond' },
        { key: 'crypto', symbolType: 'crypto' },
        { key: 'comodity', symbolType: 'comodity' },
        { key: 'pairs', symbolType: 'pairs' },
        { key: 'rest', symbolType: 'rest' },
        { key: 'stocks', symbolType: 'stocks' }
      ];
  
      // Process all positions in parallel
      const positionRequests = positionTypes.flatMap(({ key, symbolType }) => 
        userPositions.data[0][key].map(id => 
          axios.get(`positions/getShopSignalById/${id}`)
            .then(response => {
              if (response.data?.length) {
                return { ...response.data[0], symbolType };
              }
              return null;
            })
        )
      );
  
      // Wait for all requests to complete and filter out nulls
      const allPositions = (await Promise.all(positionRequests)).filter(Boolean);
  
      // Sort positions by insertTime
      const sortedPositions = allPositions.sort((a, b) => b.insertTime - a.insertTime);
  
      // Process positions for display
      const openPositionsEndDates = [];
      const rows = sortedPositions.map((position, index) => {
        if (position.pipsed !== undefined) {
          position.pipsed = position.pipsed?.toFixed(5);
        }
        
        if (position.succeeded === undefined) {
          openPositionsEndDates.push(position.endDate);
        }
  
        return createData(
          index + 1,
          position.symbol,
          position.buySell,
          position.date + " "+ position.openTime,
          position.endDate +  " "+ position.closeTime,
          position.marketOpenPositionPrice,
          position.marketClosePositionPrice,
          String(position.succeeded),
          position.pips,
          position.Precent,
          position._id,
          position.type
        );
      });
  
      props.passEndDates(openPositionsEndDates);
      let finalArray = addSuccessRate(rows);
  
      console.log("track records",trackRecord,finalArray);
      if (trackRecord) {
        finalArray = finalArray.filter((position) => {

          let text = JSON.stringify(position);
          console.log(text.includes(trackRecord))

          if(text.includes(trackRecord)){
             return true;
          }
        })
      }
  
      setPositions(finalArray);
    } catch (error) {
      console.error('Error fetching user data:', error);
      // Handle error appropriately (e.g., show error message to user)
    }
  };


 //פונקציה בשביל ה TRACK RECORD לאיציק
  const handleTrackRecordChange = ({target}) => {
    console.log(target.value);
    setTrackRecord(target.value);
   // setOpenSymbols(target.value);
  }

  //קיראה לפונקציה שמביאה את כל המידע על המשתמש כשהדף עולה
  useEffect(() => {
    getUserData();
  }, [])

  //קריאה לקומפוננטה הראשית שצריך לרנדר את הטבלה מחדש
  useEffect(() => {
    if (props.reRender === true) {
      getUserData();
    }
  }, [props.reRender]);

  useEffect(() => {
      getUserData();
  
  }, [trackRecord]);

  
  useEffect(() => {
    if (openSymbols === 'crypto') {
      cryptoSymbols();
    }
    if (openSymbols === 'pairs') {
      pairsSymbols();
    }
    if (openSymbols === 'bonds') {
      bondsSymbols();
    }
    if (openSymbols === 'comodity') {
      comoditySymbols();
    }
    if (openSymbols === 'indexes') {
      indexesSymbols();
    }
    if (openSymbols === 'stocks') {
      stocksSymbols();
    }
  }, [openSymbols])

  return (
    <Paper className={classes.root} style={{ paddingTop: '20px' }}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column, idx) => ( //מאפינג לעמודות
                <TableCell
                  key={idx} //מזהה
                  align={column.align}
                  style={{ minWidth: column.minWidth, textAlign: 'center', backgroundColor: 'lightBlue' }} //סטיילינג
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
            positions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, idx) => { //מאפינג לדפים
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                  {columns.map((column, idx) => { //  מאפינג שורות לתוך הטבלה
                    const value = row[column.id];
                    return (
                      <TableCell key={idx} align={column.align} style={{ textAlign: 'center', fontSize: '11px', height: '16.5px', borderBottom: '1px solid black' }}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination //פאג'ינציה (דפים)
        rowsPerPageOptions={[10]} //אפשרות לתת למשתמש לבחור כמות שורות בדף כרגע האפשרות היחידה היא 10
        component="div"
        count={positions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />

     {
      /*
      <FormControl style={{width: '180px', position: 'relative', bottom: '25px', float: 'right', right: '10px'}} >
        <InputLabel style={{width: '180px', color: 'black'}} >Available Symbols</InputLabel>
        <NativeSelect style={{width: '180px'}} 
          value={openSymbols}
          onChange={handleAvailableSymbolsChange}
        >
          <option aria-label="None" value=""/>
          <option value={'crypto'}>Crypto Symbols</option>
          <option value={'pairs'}>Currency Pairs Symbols</option>
          <option value={'stocks'}>Stocks Symbols</option>
          <option value={'bonds'}>Bonds Symbols</option>
          <option value={'comodity'}>Comodity Symbols</option>
          <option value={'indexes'}>Indexes Symbols</option>
        </NativeSelect>
      </FormControl>
      */
}

      <FormControl style={{width: '180px', position: 'relative', bottom: '25px', float: 'right', right: '50px'}} >
        <InputLabel style={{width: '180px', color: 'black'}} >Track Records</InputLabel>
        <NativeSelect style={{width: '180px'}} 
          value={trackRecord}
          onChange={handleTrackRecordChange}
        >
          <option aria-label="None" value=""/>
          <option value={'crypto'}>Track-Record Crypto Symbols</option>
          <option value={'pairs'}>Track-Record Currency Pairs Symbols</option>
          <option value={'stocks'}>Track-Record Stocks Symbols</option>
          <option value={'bonds'}>Track-Record Bonds Symbols</option>
          <option value={'comodity'}>Track-Record Commodity Symbols</option>
          <option value={'indexes'}>Track-Record Indexes Symbols</option>
        </NativeSelect>
      </FormControl>
      <Button
        onClick={() => props.PdfArray(positions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))}
        variant="contained"
        color="primary"
        style={
          { fontSize: '14px', position: 'relative', left: '5px', bottom: '10px' }
        }>
        Download (xlsx)
      </Button>
    </Paper>
  );
}